export enum SelectColorSize {
	Size20 = 20,
	Size30 = 30,
}

export interface IColorSelectProps {
	items: string[];
	value?: string;
	size?: SelectColorSize;
	count?: number;
	onChange: (value: string) => void;
}

export const getHex = (color: string) => {
	if (color.startsWith('#')) {
		return color;
	}

	return `#${color}`;
};
